import React from 'react';
import { Row, Col } from 'antd';

import Header from '../Landing/HomeHeader';
import Footer from './Footer';

import style from './BusinessComplianceServices.module.scss';

export default function BusinessComplianceServices() {
  return (
    <>
      <Header />
      <main className="typography">
        <section className={style.heroSection}>
          <div className="container">
            <div className={style.heroRow}>
              <div className={style.heroText}>
                <h1 className="info-title underline">Dependable Compliance</h1>
                <h3 className="info-subtitle">
                  Now more than ever, compliance is the biggest risk of doing
                  business
                </h3>
                <p>
                  Let’s paint a picture of what the contingent work world looks
                  like for staffing owners:
                </p>
              </div>
              <div className={style.heroHex}>
                <div className={style.hexMain}>
                  <div className={style.circleBox}>
                    <div className={style.circle}>
                      <div className={style.circleText}>
                        <strong>Dependable</strong>
                        compliance
                      </div>
                    </div>
                  </div>
                </div>
                <div className={style.hexBox}>
                  <div className={style.hexText}>
                    Organizations are rapidly increasing their demand for agile
                    external workers
                  </div>
                </div>
                <div className={style.hexBox}>
                  <div className={style.hexText}>
                    Client vendor setup requirements ensure absolute adherence
                    to compliance practices
                  </div>
                </div>
                <div className={style.hexBox}>
                  <div className={style.hexText}>
                    Talents pools are made up of variours worker types as the
                    typical employee profile evolves
                  </div>
                </div>
                <div className={style.hexBox}>
                  <div className={style.hexText}>
                    Regulatory entities are cracking down on compliance issues
                    in a swiftly changing worker market
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className={style.infoSection}>
          <div className="container">
            <h3 className="info-subtitle">
              myBasePay lets you focus on talent, revenue generation and growth:
            </h3>
            <div className={style.description}>
              Compliance concerns and liabilities are significantly minimized
              when you outsource these responsibilities to myBasePay. Our
              compliant practices offer complete assurance that all worker
              liabilities are met.
            </div>
            <h3 className="info-subtitle underline">Our adaptive team:</h3>
            <ul className="default-list rectangle">
              <li>
                Monitors and upholds the ever-shifting legal landscape of hiring
                contract professionals
              </li>
              <li>
                Makes it safe to hire all worker types: W2’s, Independent
                Contractors and Sub-Contractors
              </li>
              <li>
                Absorbs the risks involved with hiring independent contractors
              </li>
              <li>Is held accountable for the strictest client requirements</li>
            </ul>
          </div>
        </section>
        <section className={style.aboutSection}>
          <div className="container">
            <h3 className="info-subtitle underline">
              Protecting staffing organizations and their clients:
            </h3>
            <p>
              A noncompliant scenario risks both the staffing agency and the
              end-client. There is no margin for error when all parties can be
              held liable for …
            </p>
            <ul className="default-list check">
              <li>Wages and employer taxes</li>
              <li>Benefits/unemployment claims</li>
              <li>Discrimination claims</li>
              <li>Harassment claims</li>
              <li>Workers compensation claims.</li>
            </ul>
            <h3 className="info-subtitle underline">
              As a staffing owner, ask yourself:
            </h3>
            <ul className="default-list rectangle">
              <li>
                Are you confident in your adherence to all applicable compliance
                requirements?
              </li>
              <li>
                Do you have procedures in place to routinely audit your team's
                current practices?
              </li>
              <li>
                Have you considered the risk to your clients when compliance is
                not adequately fulfilled?
              </li>
              <li>
                Do you pre-screen other outsourcing providers to ensure they
                uphold compliance?
              </li>
            </ul>
            <h3 className="info-subtitle underline center">
              Your compliance fulfillment problems are solved by our solutions
            </h3>
            <div className={style.bgBox}>
              <div className={style.tableBox}>
                <div className="table-main">
                  <table>
                    <thead>
                      <tr>
                        <th>Compliance Risk</th>
                        <th>MBP Solution</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Improper Worker Categorization</td>
                        <td>Proprietary Classification Processes</td>
                      </tr>
                      <tr>
                        <td>Client Contract Fulfillment</td>
                        <td>Risk Mitigation and Legal Guidance</td>
                      </tr>
                      <tr>
                        <td>ACA Compliance</td>
                        <td>Employer-Sponsored Health Benefits</td>
                      </tr>
                      <tr>
                        <td>Statutory PTO Programs across localities</td>
                        <td>Nationwide PTO Eligibility for all employees</td>
                      </tr>
                      <tr>
                        <td>Harassment and Discrimination Complaints</td>
                        <td>
                          Investigative processes and complaint procedures
                        </td>
                      </tr>
                      <tr>
                        <td>Work Authorization Verifications</td>
                        <td>
                          I-9 Timeliness and Standardized E-Verify Protocols
                        </td>
                      </tr>
                      <tr>
                        <td>Costly insurance policies</td>
                        <td>
                          Robust insurance policies extended to all employees
                        </td>
                      </tr>
                      <tr>
                        <td>Joint Employer/Co-Employer Liability</td>
                        <td>
                          Worker liabilities are met & exceeded by one entity
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <h3 className="info-subtitle underline">
              Governments are propelling labor regulations into the modern era.
            </h3>
            <Row gutter={[40, 34]}>
              <Col xs={24} sm={12} xl={9} className="d-flex">
                <div className="feature-card">
                  <div className="feature-text">
                    Submission of violations is easier than ever through
                    user-friendly tech platforms
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={12} xl={9} className="d-flex">
                <div className="feature-card">
                  <div className="feature-text">
                    Increased regulations are constantly changing compliance
                    practices and burdening administrative oversight
                  </div>
                </div>
              </Col>
            </Row>
            <Row gutter={[40, 34]} justify="end">
              <Col xs={24} sm={12} xl={9} className="d-flex">
                <div className="feature-card">
                  <div className="feature-text">
                    Whistleblower reward programs created by government entities
                    incentivize reporting
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={12} xl={9} className="d-flex">
                <div className="feature-card">
                  <div className="feature-text">
                    Increased taskforces, compliance resources, and manpower
                    across all sectors of regulatory entities
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
